<template>
  <div
    v-if="open"
    class="panel-overlay-scrim"
    aria-hidden="true"
    @click="$emit('dismiss')"
  ></div>
</template>

<script>
/**
 * The dimmed backdrop behind a left panel rendered as a compact-band overlay.
 *
 * `05-sidebar-system.md` §3.3 requires that Overlay "adds a scrim over the
 * content region, closes on scrim click, on `Escape`, and on route change" and
 * that it traps focus, because at that size the panel is a modal surface. Those
 * four behaviours are not polish: an overlay that covers the content but leaves
 * it clickable, or that keyboard focus can walk out of and get lost behind, is
 * worse than not shipping the state at all.
 *
 * The scrim owns exactly one of the four -- the click -- and the panel owns the
 * rest, because dismissal on Escape and on route change has to work whether or
 * not the pointer is over the scrim, and the focus trap belongs to the element
 * that holds the focusable content.
 *
 * `aria-hidden` because it is decoration plus a hit target; the accessible way
 * to dismiss is Escape, which the panel handles.
 */
export default {
  name: 'PanelOverlayScrim',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['dismiss'],
}
</script>
